import { render } from "./CountryDetail.vue?vue&type=template&id=27286097&scoped=true"
import script from "./CountryDetail.vue?vue&type=script&lang=js"
export * from "./CountryDetail.vue?vue&type=script&lang=js"

import "./CountryDetail.vue?vue&type=style&index=0&id=27286097&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27286097"]])

export default __exports__